import _ from "lodash";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";

import { DashboardShifts } from "@/Components/common/client/dashboard/shifts/DashboardShifts";
import { UpcomingBookings } from "@/Components/common/client/dashboard/UpcomingBookings";
import { updateactivePages } from "@/reducers/clientcommon";
import { resetDashboard } from "@/reducers/clientdashboard";

import { CandidateTypes } from "../../Components/common/client/candidates/CandidateTypes";
import useTitle from "../../utilities/hooks/useTitle";
import { showErrorToast } from "../../utilities/utils";
/**
 * A functional component for the Dashboard.
 *
 * @return {JSX.Element} The Dashboard component
 */
const Dashboard = () => {
  const location = useLocation();
  useTitle("Dashboard");
  const dispatch = useDispatch();
  useEffect(() => {
    const { state } = location;
    if (!_.isEmpty(state)) {
      if (state.message) {
        setTimeout(() => {
          showErrorToast(state.message, {
            id: state.message.replace(" ", ""),
          });
        }, 300);
      }
    }

    dispatch(resetDashboard());
    dispatch(
      updateactivePages({
        activePage: "dashboard",
        activeSubPage: null,
      }),
    );
  }, []);
  return (
    <>
      {/* <Head title="Dashboard" /> */}
      <div className="flex flex-col gap-4">
        <CandidateTypes />
        <UpcomingBookings />
        <DashboardShifts />
      </div>
    </>
  );
};

export default Dashboard;
